import { Routes } from '@angular/router';

import { authGuard } from './core/guards/auth.guard';
import { fallbackGuard } from './core/guards/fallback.guard';
import { analyticsRoutes } from './features/analytics/routes';
import { auditRoutes } from './features/audits/routes';
import { authAppRoutes, authPublicRoutes } from './features/auth/routes';
import { categoryRoutes } from './features/categories/routes';
import { enclaveRoutes } from './features/enclaves/routes';
import { newsRoutes } from './features/news/routes';
import { routeRoutes } from './features/routes/routes';
import { userRoutes } from './features/users/routes';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    canActivate: [fallbackGuard],
    loadComponent: () =>
      import('./features/auth/pages/forbidden/forbidden').then((m) => m.AuthForbidden),
  },
  {
    path: '',
    loadComponent: () =>
      import('./shared/layout/auth-layout/auth-layout').then((m) => m.AuthLayout),
    children: authPublicRoutes,
  },
  {
    path: '',
    loadComponent: () => import('./shared/layout/app-layout/app-layout').then((m) => m.AppLayout),
    canActivateChild: [authGuard],
    children: [
      ...analyticsRoutes,
      ...authAppRoutes,
      ...auditRoutes,
      ...categoryRoutes,
      ...enclaveRoutes,
      ...newsRoutes,
      ...routeRoutes,
      ...userRoutes,
    ],
  },
  {
    path: '**',
    canActivate: [fallbackGuard],
    loadComponent: () =>
      import('./features/auth/pages/forbidden/forbidden').then((m) => m.AuthForbidden),
  },
];
